import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const item = css`
  flex: 1;
  height: 100%;

  &:last-child {
    flex: none;
  }
`;

const itemWrapper = css`
  height: 100%;
  align-items: flex-start !important;
  flex-direction: column-reverse !important;
`;

const itemTitle = css`
  width: 100px;
  flex: 1;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-weight: 700;

  @media screen and (max-width: 768px) and (min-width: 576px) {
    display: none;
  }
`;

const itemSection = css`
  flex: 1;
  justify-content: left;
  display: flex;
  margin-bottom: 8px;
`;

const itemRail = css`
  position: absolute;
  top: unset !important;
  bottom: 8px;
  width: calc(100% - 9px) !important;
  border-width: 0 0 2px 0;
  left: 61px !important;
  margin: 0;
`;

export const stepIcon = css`
  width: 20px;
  height: 20px;
  border: 3px solid ${colors['@grey-20']};
  border-radius: 10px;
  display: block;

  &.process {
    border-color: ${colors['@primary-color']};
  }

  &.finish {
    border-color: ${colors['@primary-color']};
    background-color: ${colors['@primary-color']};
  }
  &.error {
    border-color: ${colors['@error-color-dark']};
  }
`;

export const root = css`
  /* Override Ant Design Steps styles to match Fleetback design system */
  &.ant-steps {
    &.ant-steps-horizontal {
      > .ant-steps-item {
        ${item}
        > .ant-steps-item-wrapper {
          ${itemWrapper}
          /* iconRender always substitutes our own .icon, so antd's own -item-icon is never rendered. */
          > .icon {
            margin-left: 38px;
          }
          > .ant-steps-item-section {
            ${itemSection}
            > .ant-steps-item-header {
              > .ant-steps-item-title {
                ${itemTitle}
              }
              > .ant-steps-item-rail {
                ${itemRail}
              }
            }
          }
        }
      }
    }

    /* Override vertical steps styles */
    &.ant-steps-vertical {
      > .ant-steps-item {
        > .ant-steps-item-wrapper {
          > .ant-steps-item-section {
            > .ant-steps-item-header {
              > .ant-steps-item-rail {
                top: 25px;
                left: 9px !important;
              }
            }
          }
        }
      }
    }
  }
`;
